<template>
    <div>
        <div class="modal fade" id="project-document-selection-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{project.name}} resource file(s)</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body project-document-selection-table">

                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <table class="table table-bordered" id="project-file-selection-table" >
                                        <thead>
                                        <tr>
                                            <th scope="col" class="col-1">Selection</th>
                                            <th scope="col" class="col-2">Name</th>
                                            <th scope="col">File</th>
                                            <th scope="col" class="col-2">Folder</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(resourceFile, index) in resourceFiles">
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    class="form-control bg-transparent shadow-none p-0 m-0 project-document-selection-input"
                                                    :id="'customCheck'+resourceFile.id"
                                                    :value="resourceFile.id"
                                                    :name="resourceFile.name"
                                                    @change="selectUnselectFile(resourceFile.id)"
                                                >
                                            </td>
                                            <td class="text-xs">{{ resourceFile.name }}</td>
                                            <td><img class="project-document-selection-img" :src="(resourceFile.type == 'document')? resourceFile.thumbnail : resourceFile.path" /></td>
                                            <td><span class="directory-name-tag">{{ resourceFile.directory_name }}</span></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div v-if="loadingFiles" class="w-full text-center">
                                        <i class="fa fa-spin fa-spinner text-grey-darkest"
                                           aria-hidden="true"></i>
                                    </div>
                                    <div v-else-if="resourceFiles.length == 0 && !loadingFiles" class="w-full text-center">
                                        No files added against this project.
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="selectFiles()">Add Selected Files</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'external-email-project-document-select-modal',
    props: ['project'],
    data() {
        return {
            resourceFiles: [],
            selectedFiles: [],
            loadingFiles: true,
        }
    },
    mounted() {
        this.getResourceFiles();

        let dataTableCustomScript = document.createElement("script");
        dataTableCustomScript.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/datatables/1.10.20/js/jquery.dataTables.min.js");
        document.head.appendChild(dataTableCustomScript);

        let dataTableBS4CustomScript = document.createElement("script");
        dataTableBS4CustomScript.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/datatables/1.10.20/js/dataTables.bootstrap4.min.js");
        document.head.appendChild(dataTableBS4CustomScript);
    },
    created() {
    },
    methods: {
        open(){
            this.selectedFiles = [];
            $('#project-document-selection-modal').modal('show');
        },
        getResourceFiles(){
            let self = this;
            axios.post(route('api.resource-file.external-email-selection'), {projectId: self.project.id}).then(response => {
                self.resourceFiles = response.data.resourceFiles;
                    $(document).ready(function() {
                        $('#project-file-selection-table').DataTable();
                        self.loadingFiles = false;
                    });
            });
        },
        selectUnselectFile(id){
            if(this.selectedFiles.includes(id)){
                let index = this.selectedFiles.indexOf(id);
                this.selectedFiles.splice(index, 1);
            }else{
                this.selectedFiles.push(id);
            }
        },
        selectFiles(){
            this.$nextTick(() => {
               this.resourceFiles.forEach(item => {
                  this.selectedFiles.forEach(file => {
                     if(item.id == file){
                         this.$parent.selectedFiles.push(item);
                     }
                  });
               });
                $('#project-document-selection-modal').modal('hide');
            });
        }
    }
}
</script>
<style>
.project-document-selection-table .container {
        padding: 2rem 0rem;
}

.project-document-selection-table h4 {
        margin: 2rem 0rem 1rem;
}

.project-document-selection-table .table-image {
    td, th {
        vertical-align: middle;
    }
}

img.project-document-selection-img {
    max-width: 80px;
    height: auto;
    max-height: 250px;
}

.project-document-selection-table .project-document-selection-input {
    max-width: 18px;
    margin: 0 auto !important;
}

.project-document-selection-table td {
    vertical-align: middle;
    text-align: center;
    margin: 0 auto !important;
}

.modal-body.project-document-selection-table {
    max-height: 50vh;
    overflow: scroll;
}

span.directory-name-tag {
    background: #01b1af;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
}

@import "https://cdnjs.cloudflare.com/ajax/libs/datatables/1.10.20/css/dataTables.bootstrap4.min.css";
</style>
